import {Module} from 'vuex';
import {RootState} from '@/types';
import PermissionAPI from '@/api/PermissionAPI';
import {SET_PERMISSION, SET_PERMISSIONS} from '@/store/mutationTypes';
import {namespace} from 'vuex-class';

export const permissionsModule = namespace('permissions');

export interface PermissionChildren {
  group_name: string;
  permissions?: Permission[];
  [key: string]: any;
}

export interface Permission {
  id: number | string | null;
  name: string;
  permissions?: PermissionChildren[];

  [key: string]: any;
}

interface PermissionState {
  permissions: Permission[];
  permission: Permission | null;
}

export default <Module<PermissionState, RootState>>{
  namespaced: true,
  state: {
    permissions: [],
    permission: null,
  },
  mutations: {
    [SET_PERMISSIONS](state, data) {
      state.permissions = data;
    },
    [SET_PERMISSION](state, data) {
      state.permission = data;
    },
  },
  actions: {
    async all({commit}, params = {paginate: false}) {
      try {
        const {data} = await PermissionAPI.all(params);
        if (!params.paginate) {
          commit(SET_PERMISSIONS, data.data);
        } else {
          commit(SET_PERMISSIONS, data.data.data);
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detail({commit}, id) {
      try {
        const {data} = await PermissionAPI.detail(id);
        commit(SET_PERMISSION, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async create(_, payload) {
      try {
        const {data} = await PermissionAPI.create(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async update(_, payload) {
      try {
        const {data} = await PermissionAPI.update(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async delete(_, id) {
      try {
        const {data} = await PermissionAPI.delete(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
  getters: {},
};
